import React, { useEffect, useRef, useState } from 'react'
import { enums } from '../../../constants'
import utils, { getMessage } from '../../../utils'

import './ConfiguracaoPixAutomaticoForm.scss'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsInputNumber from '../../../components/lottus/lts-input-number'
import LtsLookupUnidade from '../../../components/lottus/lts-lookup-unidade'
import LtsPassword from '../../../components/lottus/lts-password'
import LtsLookupCertificadoDigital from '../../../components/lottus/lts-lookup-certificado-digital'
import LtsDropdownEnum from '../../../components/lottus/lts-dropdown-enum'
import LtsInputMask from '../../../components/lottus/lts-input-mask'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import LtsTextArea from '../../../components/lottus/lts-text-area'

export const ConfiguracaoPixAutomaticoForm = (props) => {
  const record = props.record
  const messages = props.messages
  const loadingValidarCredenciais = props.loadingValidarCredenciais

  const [mostrarAppKey, setMostrarAppKey] = useState(false)
  const [unidade, setUnidade] = useState({ value: '', oid: '' })
  const [certificadoDigital, setCertificadoDigital] = useState({ value: '', oid: '' })

  const toast = useRef(null)
  const [validacaoCredenciais, setValidacaoCredenciais] = useState({ requestInfo: '', responseInfo: '' })

  useEffect(() => {
    const isBB = record?.codigoPsp === 'BB'
    setMostrarAppKey(isBB)
  }, [record?.codigoPsp])

  useEffect(() => {
    if (record.unidade && record.unidade.id) {
      setUnidade({ value: record.unidade.value || '', oid: record.unidade.id })
    } else {
      setUnidade({ value: '', oid: '' })
    }
  }, [record.unidade])

  useEffect(() => {
    if (record.certificadoDigital && record.certificadoDigital.id) {
      setCertificadoDigital({ value: record.certificadoDigital.value || '', oid: record.certificadoDigital.id })
    } else {
      setCertificadoDigital({ value: '', oid: '' })
    }
  }, [record.certificadoDigital])

  const calculateRowsByContent = (content, minRows = 5, maxRows = 30, lineLength = 120) => {
    if (!content) return minRows
    const estimatedRows = content.split('\n').reduce((acc, line) => {
      const currentLineLength = line?.length ?? 0
      const wrappedLines = Math.max(1, Math.ceil(currentLineLength / lineLength))
      return acc + wrappedLines
    }, 0)
    return Math.max(minRows, Math.min(maxRows, estimatedRows))
  }

  const handleValidarCredenciais = () => {
    const dados = {
      codigoPsp: record.codigoPsp,
      ambiente: record.ambiente,
      clientId: record.clientId,
      clientSecret: record.clientSecret,
      appKey: record.appKey,
      certificadoDigital: record.certificadoDigital,
    }

    props.validarCredenciais(dados)
      .then((response) => {
        const data = response.data || {}
        setValidacaoCredenciais({
          requestInfo: data.requestInfo || '',
          responseInfo: data.responseBody || '',
        })
        toast.current.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Credenciais validadas com sucesso!',
          life: 5000,
        })
      })
      .catch((error) => {
        const errorData = error.response?.data || {}

        setValidacaoCredenciais({
          requestInfo: errorData.requestInfo || '',
          responseInfo: errorData.responseBody || errorData.mensagem || 'Erro ao validar credenciais',
        })

        let detailMessage = errorData.mensagem || errorData.error || 'Erro ao validar credenciais'

        if (errorData.responseBody) {
          try {
            const responseBody =
              typeof errorData.responseBody === 'string'
                ? JSON.parse(errorData.responseBody)
                : errorData.responseBody
            if (responseBody.error_description) {
              detailMessage += `\n\nDetalhes: ${responseBody.error_description}`
            } else if (responseBody.error) {
              detailMessage += `\n\nDetalhes: ${responseBody.error}`
            }
          } catch (e) {
            detailMessage += `\n\nDetalhes: ${errorData.responseBody}`
          }
        }

        if (errorData.statusCode) {
          detailMessage += `\n\nStatus Code: ${errorData.statusCode}`
        }

        toast.current.show({
          severity: 'error',
          summary: `Erro - ${errorData.psp || 'Validação'}`,
          detail: detailMessage,
          life: 8000,
        })
      })
  }

  const isCredenciaisPreenchidas = () => {
    const camposObrigatorios = [record.codigoPsp, record.ambiente, record.clientId, record.clientSecret, record.certificadoDigital?.id]

    if (mostrarAppKey) {
      camposObrigatorios.push(record.appKey)
    }

    return camposObrigatorios.every((campo) => campo && campo.toString().trim() !== '')
  }

  const getValidacaoCredenciais = () => {
    const requestRows  = calculateRowsByContent(validacaoCredenciais.requestInfo)
    const responseRows = calculateRowsByContent(validacaoCredenciais.responseInfo)

    return (
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>{utils.getMessage(messages, 'configuracaopixautomatico.label.validacaocredenciais')}</h3>
          <div className="p-grid form-group">
            <div className="p-col-12">
              <Button
                label={loadingValidarCredenciais
                  ? getMessage(messages, 'configuracaopixautomatico.label.validandocredenciais')
                  : getMessage(messages, 'configuracaopixautomatico.label.checarcredenciais')}
                icon="pi pi-cloud-upload"
                style={{ width: 'auto' }}
                disabled={!isCredenciaisPreenchidas() || loadingValidarCredenciais}
                loading={loadingValidarCredenciais}
                onClick={handleValidarCredenciais}
              />
            </div>
            <div className="p-col-12">
              <LtsTextArea
                value={validacaoCredenciais.requestInfo}
                name="validacaoCredenciaisRequest"
                rows={requestRows}
                label={getMessage(messages, 'configuracaopixautomatico.label.validacaoCredenciaisRequest')}
                readOnly={true}
              />
            </div>
            <div className="p-col-12">
              <LtsTextArea
                value={validacaoCredenciais.responseInfo}
                name="validacaoCredenciaisResponse"
                rows={responseRows}
                label={getMessage(messages, 'configuracaopixautomatico.label.validacaoCredenciaisResponse')}
                readOnly={true}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="p-grid p-fluid configuracao-pix-automatico-form">
      <Toast ref={toast} />
      {/* SEÇÃO 1: IDENTIFICAÇÃO */}
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>{utils.getMessage(messages, 'configuracaopixautomatico.label.configuracaopixautomatico')}</h3>
          <div className="p-grid form-group">
            <div className="p-col-12 p-md-6">
              <LtsLookupUnidade
                disabled={props.disableUnit}
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.unidade')}
                value={unidade.value}
                oidRecord={unidade.oid}
                history={props.history}
                onChange={(e) => props.onChangeField('unidade', e)}
              />
            </div>
            <div className="p-col-12 p-md-6 fix-float-label">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.nome')}
                value={record.nome}
                onChange={(e) => props.onChangeField('nome', e)}
                name="nome"
              />
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÃO 2: PSP E AMBIENTE */}
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>{utils.getMessage(messages, 'configuracaopixautomatico.label.pspambiente')}</h3>
          <div className="p-grid form-group">
            <div className="p-col-12 p-md-6">
              <LtsDropdownEnum
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.pspbanco')}
                value={record.codigoPsp}
                options={enums.CodigoPsp}
                onChange={(e) => props.onChangeField('codigoPsp', e)}
                optionLabel="value"
                optionValue="id"
                name="codigoPsp"
              />
            </div>

            <div className="p-col-12 p-md-6">
              <LtsDropdownEnum
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.ambiente')}
                value={record.ambiente}
                options={enums.AmbientePixAutomatico}
                onChange={(e) => props.onChangeField('ambiente', e)}
                optionLabel="value"
                optionValue="id"
                name="ambiente"
              />
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÃO 3: CREDENCIAIS OAUTH */}
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>{utils.getMessage(messages, 'configuracaopixautomatico.label.credenciaisoauth')}</h3>
          <div className="p-grid form-group">
            <div className="p-col-12 p-md-6">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.clientid')}
                value={record.clientId}
                onChange={(e) => props.onChangeField('clientId', e)}
                name="clientId"
                autoComplete="off"
              />
            </div>

            <div className="p-col-12 p-md-6">
              <LtsPassword
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.clientsecret')}
                onChange={(e) => props.onChangeField('clientSecret', e)}
                name="clientSecret"
                value={record.clientSecret}
                toggleMask
                autoComplete="new-password"
              />
            </div>

            {mostrarAppKey && (
              <div className="p-col-12 p-md-6 fix-float-label">
                <LtsInputText
                  label={utils.getMessage(messages, 'configuracaopixautomatico.label.appkey')}
                  value={record.appKey}
                  onChange={(e) => props.onChangeField('appKey', e)}
                  name="appKey"
                />
              </div>
            )}

            <div className="p-col-12 p-md-6">
              <LtsLookupCertificadoDigital
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.certificadodigital')}
                value={certificadoDigital.value}
                oidRecord={certificadoDigital.oid}
                history={props.history}
                onChange={(e) => props.setCertificadoDigital(e)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÃO: VALIDAÇÃO DE CREDENCIAIS */}
      {getValidacaoCredenciais()}

      {/* SEÇÃO 4: JORNADA */}
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>{utils.getMessage(messages, 'configuracaopixautomatico.label.jornadaepolitica')}</h3>
          <div className="p-grid form-group">
            <div className="p-col-12 p-md-4">
              <LtsDropdownEnum
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.jornadaativa')}
                value={record.jornadaAtiva}
                options={enums.JornadaAtivaPixAutomatico}
                onChange={(e) => props.onChangeField('jornadaAtiva', e)}
                optionLabel="value"
                optionValue="id"
                name="jornadaAtiva"
              />
            </div>

            <div className="p-col-12 p-md-4">
              <LtsInputNumber
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.diasexpiracaosolicitacao')}
                value={record.diasExpiracaoSolicitacao}
                onChange={(e) => props.onChangeField('diasExpiracaoSolicitacao', e)}
                name="diasExpiracaoSolicitacao"
                min={1}
                max={30}
              />
            </div>

            <div className="p-col-12 p-md-4">
              <LtsDropdownEnum
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.politicaretentativa')}
                value={record.politicaRetentativa}
                options={enums.PoliticaRetentativa}
                onChange={(e) => props.onChangeField('politicaRetentativa', e)}
                optionLabel="value"
                optionValue="id"
                name="politicaRetentativa"
              />
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÃO 5: RECEBEDOR */}
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>{utils.getMessage(messages, 'configuracaopixautomatico.label.dadosrecebedor')}</h3>
          <div className="p-grid form-group">
            <div className="p-col-12 p-md-4">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.nomerecebedor')}
                value={record.recebedorNome}
                onChange={(e) => props.onChangeField('recebedorNome', e)}
                name="recebedorNome"
              />
            </div>

            <div className="p-col-12 p-md-4">
              <LtsInputMask
                mask="99.999.999/9999-99"
                unmask={true}
                value={record.recebedorCnpj}
                onChange={(value) => props.onChangeField('recebedorCnpj', value)}
                name="recebedorCnpj"
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.cnpjrecebedor')}
              />
            </div>

            <div className="p-col-12 p-md-4">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.conveniopix')}
                value={record.convenioPix}
                onChange={(e) => props.onChangeField('convenioPix', e)}
                name="convenioPix"
              />
            </div>

            <div className="p-col-12 p-md-4">
              <LtsDropdownEnum
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.tipoconta')}
                value={record.recebedorTipoConta}
                options={enums.TipoContaRecebedor}
                onChange={(e) => props.onChangeField('recebedorTipoConta', e)}
                optionLabel="value"
                optionValue="id"
                name="recebedorTipoConta"
              />
            </div>
            <div className="p-col-12 p-md-4">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.agencia')}
                value={record.recebedorAgencia}
                onChange={(e) => props.onChangeField('recebedorAgencia', e)}
                name="recebedorAgencia"
              />
            </div>
            <div className="p-col-12 p-md-4">
              <LtsInputText
                label={utils.getMessage(messages, 'configuracaopixautomatico.label.conta')}
                value={record.recebedorConta}
                onChange={(e) => props.onChangeField('recebedorConta', e)}
                name="recebedorConta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
